export default {
    TABLE_TITLE: 'Module Categories',
    MODULE_CATEGORY_ADDED: 'Module Category added',
    MODULE_CATEGORY_EDITED: 'Module Category edited',
    MODULE_CATEGORY_DELETED: 'Module Category deleted',
};
